import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWorksServicePaymentRateNorms(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].GET_WORKS_SERVICE_PAYMENT_RATE_NORMS,
		options
	)
}

function _createWorksServicePaymentRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].CREATE_WORKS_SERVICE_PAYMENT_RATE_NORM,
		options
	)
}

function _getWorksServicePaymentRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].GET_WORKS_SERVICE_PAYMENT_RATE_NORM,
		options
	)
}

function _patchWorksServicePaymentRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].PATCH_WORKS_SERVICE_PAYMENT_RATE_NORM,
		options
	)
}

function _putWorksServicePaymentRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].PUT_WORKS_SERVICE_PAYMENT_RATE_NORM,
		options
	)
}

function _deleteWorksServicePaymentRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].DELETE_WORKS_SERVICE_PAYMENT_RATE_NORM,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].GET_WORKS_SERVICE_PAYMENT_RATE_NORMS]: _getWorksServicePaymentRateNorms,
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].CREATE_WORKS_SERVICE_PAYMENT_RATE_NORM]: _createWorksServicePaymentRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].GET_WORKS_SERVICE_PAYMENT_RATE_NORM]: _getWorksServicePaymentRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].PATCH_WORKS_SERVICE_PAYMENT_RATE_NORM]: _patchWorksServicePaymentRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].PUT_WORKS_SERVICE_PAYMENT_RATE_NORM]: _putWorksServicePaymentRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].DELETE_WORKS_SERVICE_PAYMENT_RATE_NORM]: _deleteWorksServicePaymentRateNorm,
}